'use strict';

var $u = require('../utilities');
var $d = require('../dependency');
var _ = $d._;
var moment = $d.moment;

exports.afterApiAggregation = afterApiAggregation;
exports.afterApiAggregationCustomerPercentage = afterApiAggregationCustomerPercentage;
exports.afterApiAggregationAverage = afterApiAggregationAverage;


function afterApiAggregation(context, config, next) {
    var apiParsedResponseList = context.apiParsedResponseList,
      apiMergedResponse = {};

    _.forEach(config.aggregationFields, function (field) {
        //Merge only afterApiAggregation fields
        apiMergedResponse[field] = _.reduce(apiParsedResponseList[0][field], function (sum, n) {
            return sum + n;
        }, 0);
    });

    context.apiMergedResponse = apiMergedResponse;
    next();
}


function afterApiAggregationCustomerPercentage(context, config, next) {
    var apiParsedResponseList = context.apiParsedResponseList,
      apiMergedResponse = {}, 
      totalCustomers = apiParsedResponseList[0][config.aggregationFields[0]].length;
    _.forEach(config.aggregationFields, function (field) {
        //Merge only afterApiAggregation fields
        apiMergedResponse[field] = _.reduce(apiParsedResponseList[0][field], function (sum, n) {
            return sum + n;
        }, 0);
        apiMergedResponse[field + "_percentage"] = 100 * apiMergedResponse[field] / totalCustomers;
    });
    apiMergedResponse.totalCustomers = totalCustomers;
    context.apiMergedResponse = apiMergedResponse;
    next();
}


function afterApiAggregationAverage(context, config, next) {
    var apiParsedResponseList = context.apiParsedResponseList,
      apiMergedResponse = {};
    _.forEach(config.aggregationFields, function (field) {
        //Merge only afterApiAggregation fields
        apiMergedResponse[field] = _.reduce(apiParsedResponseList[0][field], function (sum, n) {
            return sum + n;
        }, 0);
        apiMergedResponse[field] = apiMergedResponse[field] / apiParsedResponseList[0][field].length;
    });

    context.apiMergedResponse = apiMergedResponse;
    next();
}